package co.maytes.standupbot.dashboard.components.widgets

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Spacing
import co.maytes.standupbot.dashboard.styles.Typography
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText

@Composable
fun SectionCard(
    title: String,
    modifier: Modifier = Modifier,
    description: String? = null,
    action: (@Composable () -> Unit)? = null,
    bodyPadded: Boolean = true,
    content: @Composable () -> Unit,
) {
    Card(modifier = Modifier.fillMaxWidth().then(modifier), padded = false) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(topBottom = Spacing.md, leftRight = Spacing.lg)
                .styleModifier {
                    property("border-bottom", "1px solid ${Palette.borderSubtle.cssRgb()}")
                    property("gap", "1rem")
                },
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween,
        ) {
            Column(modifier = Modifier.styleModifier { property("min-width", "0") }) {
                SpanText(
                    text = title,
                    modifier = Modifier
                        .fontSize(Typography.h4.size)
                        .fontWeight(Typography.h4.weight)
                        .color(Palette.textPrimary),
                )
                if (description != null) {
                    SpanText(
                        text = description,
                        modifier = Modifier
                            .margin(top = Spacing.xxs)
                            .fontSize(Typography.bodySmall.size)
                            .color(Palette.textSecondary),
                    )
                }
            }
            if (action != null) {
                Box(modifier = Modifier.styleModifier { property("flex-shrink", "0") }) { action() }
            }
        }
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .let { if (bodyPadded) it.padding(Spacing.lg) else it },
        ) {
            content()
        }
    }
}

@Composable
fun FormRow(
    label: String,
    modifier: Modifier = Modifier,
    hint: String? = null,
    content: @Composable () -> Unit,
) {
    Column(modifier = Modifier.fillMaxWidth().then(modifier)) {
        SpanText(
            text = label,
            modifier = Modifier
                .margin(bottom = Spacing.xxs)
                .fontSize(Typography.label.size)
                .fontWeight(Typography.label.weight)
                .color(Palette.textPrimary),
        )
        content()
        if (hint != null) {
            SpanText(
                text = hint,
                modifier = Modifier
                    .margin(top = Spacing.xxs)
                    .fontSize(Typography.caption.size)
                    .color(Palette.textTertiary),
            )
        }
    }
}

@Composable
fun SectionDivider(modifier: Modifier = Modifier) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .margin(topBottom = Spacing.lg)
            .styleModifier {
                property("height", "1px")
                property("background-color", Palette.borderSubtle.cssRgb())
            }
            .then(modifier),
    ) {}
}
